import React, { Component } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { Collapse, Button, CardBody, Card } from 'reactstrap';
import { SuccessStoryDetail } from './SuccessStoryDetail';


export class SuccessStory extends Component {
    constructor(props) {
        super(props);
        this.state = {
            successStories: [],
            hasMore: true,
            pageNumber: 0,
            countItems: 20,
            isOpen: false
        };
        this.loadMore = this.loadMore.bind(this);
    };

    loadMore() {
        const url = `api/SuccessStory/GetSuccessStories/${this.state.pageNumber}/${this.state.countItems}`;

        fetch(url).then(response => response.json())
            .then(data => {
                const items = this.state.successStories.concat(data);
                this.setState(
                    {
                        successStories: items,
                        pageNumber: this.state.pageNumber + 1,
                        hasMore: data.length === this.state.countItems,
                    }
                );
            });

    };

    showItems() {
        var items = [];
        for (var i = 0; i < this.state.successStories.length; i++) {
            items.push(

                <div className="row" key={i}>
                    <div className="col-12 mx-auto" key={i}>
                        <div className="card card-body mb-2" key={i}>
                            <div className="card-body">
                                <h5 className="card-title">{this.state.successStories[i].title}</h5>
                                <p className="card-text">
                                    {this.state.successStories[i].description}
                                </p>
                            </div>
                            <Button color="primary"
                                onClick={() => this.setState({ isOpen: !this.state.isOpen })}
                                style={{ marginBottom: '1rem' }}>
                                Fotos
                            </Button>
                            <Collapse isOpen={this.state.isOpen}>
                                <SuccessStoryDetail story={this.state.successStories[i]}>
                                </SuccessStoryDetail>
                            </Collapse>

                        </div>
                    </div>
                </div>

            );
        }
        return items;
    };

    render() {
        return (
            <div className="App" ref="myScroll">

                <InfiniteScroll
                    loadMore={this.loadMore}
                    hasMore={this.state.hasMore}
                    useWindow={true}
                    loader={<div className="loader" key={-1}>Loading ...</div>}

                >
                    <div className="card sticky-top">
                        <h1>Casos de exito</h1>
                    </div>
                    {this.showItems()}

                </InfiniteScroll>

            </div>
        );
    };
}
